import { Country } from '../enums';
import { Company } from '../models';

export const isUsCompany = (company: Company): boolean =>
  !!company.accountNumber?.toLowerCase().startsWith('u');

export const getCompanyLocation = (company: Company | null): Country =>
  company && isUsCompany(company) ? Country.UnitedStates : Country.Canada;
